import React, { Component } from "react";
import { FormHelperText, FormLabel, OutlinedInput } from "@mui/material";
import { withRouter } from "utilities/withRouter";
import validateQuote from "modules/createQuote/validateQuote";
import "./groupName.css";
import InputAdornment from "@mui/material/InputAdornment";
import BlockIcon from "@mui/icons-material/Block";
import ClearIcon from "@mui/icons-material/Clear";
import { CONFIGURATION } from "utilities/configuration";

class GroupName extends Component {

    constructor(props) {
        super(props);
        this.state = {
            groupName: this.props.groupName ?? ""
        };
    }
    
    handleClear = () => {
        let { groupName } = this.state;
        groupName = "";
        this.setState({ groupName });
        
        this.props.handleStep1Data({ target: { name: "groupName", value: "" } });
        validateQuote.isGroupNameValid(this.props.quote, this.props.errors, this.props.localize);
    };

    handleChange = (event) => {
        let { groupName } = this.state;
        groupName = event.target.value;
        this.setState({ groupName });
    };

    handleBlur = (event) => {
        this.props.handleStep1Data(event);
        validateQuote.isGroupNameValid(this.props.quote, this.props.errors, this.props.localize);
    };

    render() {
        const { error } = this.props;
        const { groupName } = this.state;
        const enabled = true; // this is a template how to add endAdornment
        return (
            <div className="row group-name">
                <div className="row form-control-wrapper">
                    <FormLabel>
                        {this.props.localize("qma-group-name")}
                    </FormLabel>
                    <OutlinedInput
                        fullWidth
                        inputProps={{ maxLength: 255 }}
                        name="groupName"
                        id="outlined-group-name"
                        value={groupName}
                        disabled={!enabled}
                        onBlur={(event) => this.handleBlur(event)}
                        onChange={(event) => this.handleChange(event)}
                        aria-describedby="outlined-group-name-helper-text"
                        error={error?.trim().length > 0}
                        endAdornment={
                            CONFIGURATION.APPLY_FIELD_ADORNMENT ? <InputAdornment position="end">
                                { enabled ? (groupName && groupName.length > 0 ? <ClearIcon className="clear-icon" onClick={this.handleClear} edge="end"/> : null) : <BlockIcon />}
                            </InputAdornment> : null
                        }
                    />
                </div>
                <FormHelperText error={error?.trim().length > 0}>
                    {error?.trim().length > 0 && (
                        error
                    )}
                </FormHelperText>
            </div>
        );
    }
}

export default withRouter(GroupName);